import { EuiButton, EuiButtonProps } from "@inscopix/ideas-eui";
import ModalCreateProject from "components/ModalProject/ModalCreateProject";
import { Tooltip } from "components/Tooltip/Tooltip";
import { Tenant } from "graphql/_Types";
import { useUserContext } from "providers/UserProvider/UserProvider";
import { useState } from "react";

/*
 * Alternative style (filled) create project button for use in empty prompt
 */
export const ButtonCreateProjectFilled = (
  props: Omit<EuiButtonProps, "onClick"> & { tenantId?: Tenant["id"] },
) => {
  const hasInternalSpaceOrTenant = useUserContext(
    (s) =>
      (s.personalSpace !== undefined && !s.personalSpace.isExternal) ||
      s.tenants.length > 0,
  );
  const [showModalCreateProject, setShowModalCreateProject] = useState(false);

  return (
    <>
      <Tooltip
        content={
          hasInternalSpaceOrTenant
            ? ""
            : "You do not have any organizations in this region you can create a project in"
        }
      >
        <EuiButton
          color="primary"
          {...props}
          onClick={() => setShowModalCreateProject(true)}
          disabled={!hasInternalSpaceOrTenant}
        >
          Create New Project
        </EuiButton>
      </Tooltip>

      {showModalCreateProject && (
        <ModalCreateProject
          tenantId={props.tenantId}
          onClose={() => setShowModalCreateProject(false)}
        />
      )}
    </>
  );
};
